import React from 'react';
import styles from '../../styles/header.module.styl';
import illustration from '../../assets/svg/header-icon.svg';

export default ({ logo }) => <img className={styles.illustration} src={logo || illustration} />;



// WEBPACK FOOTER //
// ./src/components/header/Illustration.js